import { render, staticRenderFns } from "./home_news_roll.vue?vue&type=template&id=20207828&scoped=true&"
import script from "./home_news_roll.vue?vue&type=script&lang=js&"
export * from "./home_news_roll.vue?vue&type=script&lang=js&"
import style0 from "./home_news_roll.vue?vue&type=style&index=0&id=20207828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20207828",
  null
  
)

export default component.exports